import React, { useState } from 'react';
import { Form, Button,Col,Row,Card, FloatingLabel} from 'react-bootstrap';

function SignUpForm(props)
{
  const [validated, setValidated] = useState(false);
  
  async function handleSubmit (event) {
    const form = event.currentTarget;
    var data = {};
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    const formData = new FormData(event.currentTarget);
    event.preventDefault();
    for (let [key, value] of formData.entries()) {
      data[key] = value;
    }
    console.log(data);
    let response = await fetch('https://salesforceservices.azurewebsites.net/api/createpatient?code=RVT_srVOwHUWJScEhAzyEoiumgqYYLyFr13_JC5m5HGIAzFuIaafdQ==&company=trusmile', {method: "POST",
               body: JSON.stringify(data)}).then((result)=>{
                return result.json();
               })
               console.log(response);
               console.log(props);
               if(response)
               {
                 console.log(response);
                 props.setAccountId(response[0].Id);
                 props.setFormValidated(true);
                 props.setShowCalendar(true);
               }

  };



  return (
    <Card>
    <Card.Body>
    <Form  validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
      <Form.Group as={Col} md="5" controlId="validationCustom01">
      <FloatingLabel controlId="floatingInput" label="First name" className="mb-3  gfield_label gfield_label_before_complex">
        <Form.Control
          required
          type="text"

          placeholder="First name"
          name="firstName"
        />
        </FloatingLabel>
        <Form.Control.Feedback type="invalid">Please provide your First Name.</Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md="5" controlId="validationCustom02">
      <FloatingLabel controlId="floatingInput" label="Last name" className="mb-3">
        <Form.Control
          required
          size="lg" 
          type="text"
          placeholder="Last name"
          name="lastName"
        />
        </FloatingLabel>
        <Form.Control.Feedback type="invalid">Please provide your Last Name.</Form.Control.Feedback>
      </Form.Group>
      </Row>
      <Row className="mb-3">
      <Form.Group className="mb-3" as={Col} md="5" controlId="formBasicEmail">
      <FloatingLabel controlId="floatingInput" label="Email address" className="mb-3">
        <Form.Control 
          required 
          type="email" 
          placeholder="Enter email" 
          name="personEmail"/>
          </FloatingLabel>
        <Form.Text className="text-muted">
          We'll never share your email but we may email about information relating to your appointment.
        </Form.Text>
        <Form.Control.Feedback type="invalid">Please provide your Email address.</Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md="4" controlId="validationCustom03" pattern="[0-9]{11,14}">
      <FloatingLabel controlId="floatingInput" label="Phone" className="mb-3">
        <Form.Control
          required
          placeholder="555-555-5555"
          name="personMobilePhone"
          type="tel"
        />
        </FloatingLabel>
                <Form.Text className="text-muted">
          We'll never share but may use it to verify your identity or to call you to confirm your appointment.
        </Form.Text>
        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
      </Form.Group>  
      </Row>
      <Row className="mb-3">
      <Form.Group as={Col} md="4" controlId="validationCustom03">
      <FloatingLabel controlId="floatingInput" label="Birthdate" className="mb-3">
        <Form.Control
          required
          type="date"
          name="Date_Of_Birth__c"
        />
        </FloatingLabel>
                        <Form.Text className="text-muted">
         As a medical provider, we must have your date of birth to set-up a consultation
        </Form.Text>
        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
      </Form.Group> 
      </Row>
      <Row className="mb-6">
      <Form.Group as={Col} md="12" controlId="validationCustom03">
        <Form.Label>Any notes you want to share with the medical team?</Form.Label>
        <Form.Control
          as="textarea"
          name="Description"
          rows={4}
        />
        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
      </Form.Group> 
      </Row>
      <br/>
      <Button type="submit" className="btn btn-primary gform_button button" >Select Date & Time</Button>
    </Form>
    </Card.Body>
  </Card>
  )
}

export default SignUpForm;